import React from "react";
import s from "./style.module.css";
import Page from "../../layouts/Page";
import ContentBlock from "../../components/ContentBlock";
import ScrollToHash from "../../helpers/scrollToHash";
import { Heading } from "../../components/Elements";
import useContent from "../../helpers/useContent";
import Content from "../../components/Content";
import ExternalLinkList from "../../components/ExternalLinkList";
import { ReactComponent as FurtherReading } from "../../components/Icons/further-reading.svg";
import { ReactComponent as Icon } from "../../components/Icons/mooc.svg";
import Header from "./header.svg";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const OnlineCourse = () => {
  const course = useContent(copy.course.content);
  const learn = useContent(copy.learn.content);

  return (
    <Page meta={copy.meta} title={copy.title} intro={copy.intro} image={Header}>
      <ScrollToHash />

      <ContentBlock {...copy.main} icon={<Icon />}>
        <ExternalLinkList items={copy.main.links} />

        <p>{copy.course.intro}</p>
        <br />
        <Content items={course} />

        <br />
        <h3>{copy.learn.title}</h3>

        <Content items={learn} />
      </ContentBlock>
    </Page>
  );
};

export default OnlineCourse;
